import logo from '@/assets/images/icon.png';
import { useCallback } from 'react';

const iconUrl = new URL(logo, window.location.origin).toString();

export const useNotificationPermission = () => {
  const pushNotification = useCallback(async (message: string, options?: NotificationOptions) => {
    const permission = await Notification.requestPermission();

    if (permission !== 'granted') {
      return;
    }

    const notification = new Notification('Allo', {
      body: message,
      icon: iconUrl,
      requireInteraction: true,
      ...options,
    });

    notification.onclick = () => {
      window.focus();
      notification.close();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        notification.close();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    notification.onclose = () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };

    return notification;
  }, []);

  return { pushNotification };
};
